import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <>
      <section class="error-404-section min-vh-100 d-flex align-items-center">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-8 col-md-10 col-sm-12">
              <div class="error-404-content text-center">
                <div class="error-number mb-4">
                  <h1 class="display-1 error-404-text">404</h1>
                </div>

                <div class="error-icon mb-4">
                  <i class="fas fa-exclamation-triangle"></i>
                </div>

                <div class="error-message mb-4">
                  <h2 class="head mb-3">Oops! Page Not Found</h2>
                  <p class="lead mb-4">
                    The page you are looking for might have been removed, had
                    its name changed, or is temporarily unavailable.
                  </p>
                </div>

                <div class="error-actions d-flex justify-content-center">
                  <Link
                    to="/"
                    class="main-btn d-inline-flex align-items-center"
                  >
                    Go to Homepage
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PageNotFound;
